import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from '../../util/Api';

import {
  CREATE_JOB_CARD_CLOSURE_SUCCESS,
  FETCH_JOB_CARD_CLOSURE_SUCCESS,
  GET_JOB_CARD_CLOSURE_SUCCESS,
  SAVE_JOB_CARD_CLOSURE_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import { fetchError, fetchStart, fetchSuccess } from './Common';
import { message } from "antd";
import { downloadCSV } from "../../util/methods";
import { arrayToCSV } from "./JobCard";

export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_JOB_CARD_CLOSURE_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_JOB_CARD_CLOSURE_QUERY,
    query,
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_JOB_CARD_CLOSURE_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_JOB_CARD_CLOSURE_SUCCESS,
    data,
  };
};

// export const getResource = () => {
//   return async (dispatch) => {
//
//     dispatch(fetchStart());
//
//     try {
//       const { jobCardClosure } = store.getState();
//       const { query } = jobCardClosure;
//       const response = await axios.get(`/job-card?${generateQueryString(query)}`);
//       dispatch(fetchSuccess());
//       dispatch(getResourceSuccess(response.data));
//     } catch (error) {
//       message.error(error.response.data.message);
//       dispatch(fetchError(error.response.data.message));
//       console.log('Error****:', error.response.data.message);
//     }
//   };
// };

export const getResourceForDownload = (columns, filters, selectedColumns, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { jobCardClosure } = store.getState();
      const { query } = jobCardClosure;
      const response = await axios.get(`/job-card/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, selectedColumns, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/job-card/closure`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      history.push('/job-card-closure');
      // dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log('Error****:', error);
    }
  };
};

export const updateResource = (payload, id, urlBackToJobCard) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/job-card/status-update?id=${id}`, payload);
      history.goBack();
      dispatch(fetchSuccess());
      dispatch(fetchResource(id));
      // if (urlBackToJobCard){
      //   history.push(urlBackToJobCard);
      // } else {
      //   dispatch(fetchSuccess());
      //   dispatch(fetchResource(id));
      //   history.push('/job-card-closure');
      //   // dispatch(getResource());
      // }
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};

export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {

      const { jobCard } = store.getState();
      const { report } = jobCard || {};
      if (report && report._id && report._id == id) {

        dispatch(fetchSuccess());
        dispatch(fetchResourceSuccess({ data: report }));
        return;
      }
      const response = await axios.get(`/job-card/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/job-card/closure/${id}`);
      dispatch(fetchSuccess());
      // dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};
